import { PlusIcon } from 'lucide-react'

import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'

import BusinessFormTitle from '../../../components/business-form-title'
import type { BusinessInfoType } from '../../../schemas/business-create'
import {
  BusinessInfoTypeDescriptions,
  BusinessInfoTypeLabels,
  BusinessInfoTypePerProfession,
} from '../../../schemas/business-create'

type AdditionalInfoBoxProps = {
  title: string
  description: string
  onPress: () => void
}

const ChevronDownIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
    >
      <path
        d="M6.36368 7.99997L0 1.77778L1.81816 0L10 7.99997L1.81816 16L0 14.2222L6.36368 7.99997Z"
        fill="currentColor"
      />
    </svg>
  )
}
const AdditionalInfoBox = ({ title, description, onPress }: AdditionalInfoBoxProps) => {
  return (
    <button className="group flex w-[500px] flex-row items-center justify-between gap-4" onClick={onPress}>
      <div className="flex flex-row gap-6">
        <div className="flex size-20 items-center justify-center rounded-[20px] border-[3px] border-white bg-accent opacity-70 shadow-[0px_0px_15px_0px_rgba(0,0,0,0.07)] group-hover:opacity-100">
          <PlusIcon className="size-8" />
        </div>
        <div className="flex flex-col justify-center gap-0 text-left">
          <p className="text-lg font-semibold leading-normal text-primary">{title}</p>
          <p className="text-sm font-medium leading-normal text-muted">{description}</p>
        </div>
      </div>
      <ChevronDownIcon className="size-3.5 text-border group-hover:text-primary" />
    </button>
  )
}

const AdditionalInfoAllInfoStep = ({
  onSelectInfoType,
}: {
  onSelectInfoType: (infoType: BusinessInfoType | null) => void
}) => {
  const { data: currentUser } = useMyUserData()
  const infoTypesToShow = BusinessInfoTypePerProfession[currentUser?.profession ?? 'real_estate_agent']

  return (
    <div className="flex size-full flex-col items-center justify-center gap-10 py-10">
      <div className="flex flex-col items-center gap-1 text-center">
        <BusinessFormTitle>Additional info</BusinessFormTitle>
        <p className="text-lg font-medium leading-normal text-muted">
          Add any and all information that can help Lynk grade this business for you.
        </p>
      </div>
      <div className="flex flex-col gap-4">
        {infoTypesToShow.map((infoType) => (
          <AdditionalInfoBox
            key={infoType}
            title={BusinessInfoTypeLabels[infoType]}
            description={BusinessInfoTypeDescriptions[infoType]}
            onPress={() => onSelectInfoType(infoType)}
          />
        ))}
      </div>
    </div>
  )
}

export default AdditionalInfoAllInfoStep
